import React from 'react'
import '../styles/ImageSimulPage.css'
import { useRef, useState, useEffect } from 'react'
import blindMatrix from '../utils/blindnessMatrix'
import { Link } from 'react-router-dom'
import { FaArrowLeft } from 'react-icons/fa'

const ImageSimulPage = ({imageSrc, matrixId, setMatrixId, imgProp, imgBlindType}) => {
  const canvasRef = useRef(null)
  const [newImageSrc, setNewImageSrc] = useState("")

  useEffect(() => {
    if (!imageSrc) return

    const canvas = canvasRef.current
    const ctx = canvas.getContext("2d", { willReadFrequently: true })
    const img = new Image()
    img.src = imageSrc
    img.onload = () => {
      canvas.width = imgProp[0]
      canvas.height = imgProp[1]

      ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
      const pixelData = ctx.getImageData(0, 0, canvas.width, canvas.height)
      const data = pixelData.data
      const arrMatrix = blindMatrix[Number(matrixId)]
  
      for (let i = 0; i < data.length; i += 4) {
          const r = data[i]
          const g = data[i + 1]
          const b = data[i + 2]
  
          const rNew = r * arrMatrix[0][0] + g * arrMatrix[0][1] + b * arrMatrix[0][2]
          const gNew = r * arrMatrix[1][0] + g * arrMatrix[1][1] + b * arrMatrix[1][2]
          const bNew = r * arrMatrix[2][0] + g * arrMatrix[2][1] + b * arrMatrix[2][2]
  
          data[i] = Math.min(255, Math.max(0, rNew))
          data[i + 1] = Math.min(255, Math.max(0, gNew))
          data[i + 2] = Math.min(255, Math.max(0, bNew))
      }
  
      ctx.putImageData(pixelData, 0, 0)
      setNewImageSrc(canvas.toDataURL("image/png"))
    }
  }, [imageSrc, matrixId, imgProp])

  const handleBack = () => {
    setMatrixId("0")
  }
  const time = new Date()

  return (
    <div className='img-simul-page'>
      <main>
        <nav>
            <Link to="/image-selector">
              <FaArrowLeft className='back-arrow' onClick={handleBack}/>
            </Link>
        </nav>
        <div>
          <h3>{imgBlindType}</h3>
          <canvas ref={canvasRef} className='display-image-simul'></canvas>
        </div>
        <a href={newImageSrc} download={`${imgBlindType}-${time.getTime()}`}><button>Save Image</button></a>
      </main>
    </div>
  )
}

export default ImageSimulPage